import axios from "axios";
import { formRegEx, formRegExReplacer } from "constant/regex";
import moment from "moment";
import { toast } from "react-toastify";
import { CURRENCY } from "../constant/constants";

export const apiHeader = (token, isFormData) => {
  const headers = {
    "ngrok-skip-browser-warning": "69420",
    "timezone-offset": moment().utcOffset(),
    "Content-Type": isFormData ? "multipart/form-data" : "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return { headers };
};

export const getYearRange = () => {
  const options = [{ label: "Current", value: "current" }];
  var startingYear = 1,
    maxYear = 5;
  var thisYear = new Date().getFullYear();

  for (var i = startingYear; i <= maxYear; i++) {
    var year = thisYear - i;
    let op = { label: year, value: year };
    options.push(op);
  }
  return options;
};

export const getUserName = (user) => {
  if (!user) return "N/A";
  const name = (user?.firstName || "") + " " + (user?.lastName || "");
  return name.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const formatMessageDate = (date) => {
  const messageDate = moment(date);
  const now = moment();

  if (messageDate.isSame(now, "minute")) {
    // If the date is exactly now, show the current time, e.g., 'HH:mm A'
    return now.format("HH:mm A");
  } else if (messageDate.isSame(now, "day")) {
    // If the date is today, use fromNow()
    return messageDate.fromNow();
  } else if (messageDate.isSame(now.subtract(1, "day"), "day")) {
    // If the date is yesterday, use fromNow()
    return messageDate.fromNow();
  } else {
    // Otherwise, show the date in a standard format, e.g., 'MM/DD/YYYY'
    return messageDate.format("MM/DD/YYYY");
  }
};

export const formatDate = (date) => {
  const formdatedDate = moment(date);
  return formdatedDate.format("MM/DD/YYYY");
};

export const scrollToTop = (topVal = 0) => {
  window.scrollTo({
    top: topVal,
    behavior: "smooth",
  });
};

export const formatNumber = (num) => {
  if (num % 1 === 0) {
    return `${CURRENCY}${num?.toLocaleString()}`;
  } else {
    return `${CURRENCY}${num?.toFixed(2)?.toLocaleString()}`;
  }
};

export const quillValidateHandler = (
  params,
  toastMessage = "Please fill the home cms field!"
) => {
  let flag = true;
  for (let key in params) {
    const parsedHTML = new DOMParser().parseFromString(
      params[key],
      "text/html"
    );
    const plainText = parsedHTML.body.textContent || "";
    if (plainText?.trim() === "") {
      toast.error(toastMessage);
      flag = false;
      break;
    }
  }
  return flag;
};

export const urlPattern =
  /^(https?:\/\/)(www\.)?([\w-]+\.)+[a-z]{2,6}(\/[\w-]*)*\/?$/;

export const camelCaseToLower = (str) => {
  return str.replace(formRegEx, formRegExReplacer).toLowerCase();
};

export const CreateFormData = (data) => {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  return formData;
};

export const validateNestedParams = (
  params,
  parentKey = "",
  options = { disallowEmptyArray: true }
) => {
  const formatKey = (rawKey) => {
    return rawKey
      .replace(/\[(\d+)\]/g, (_, i) => ` ${parseInt(i) + 1}`) // [0] => 1
      .split(".")
      .map(
        (part) =>
          part.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()) // capitalize
      )
      .join(" → ");
  };

  if (Array.isArray(params)) {
    if (options.disallowEmptyArray && params.length === 0) {
      toast.error(`${formatKey(parentKey)} cannot be empty`);
      return false;
    }

    for (let i = 0; i < params.length; i++) {
      const key = `${parentKey}[${i}]`;
      if (!validateNestedParams(params[i], key, options)) return false;
    }
  } else if (typeof params === "object" && params !== null) {
    const keys = Object.keys(params);
    if (keys.length === 0 && parentKey) {
      toast.error(`${formatKey(parentKey)} cannot be empty`);
      return false;
    }

    for (const key of keys) {
      const fullKey = parentKey ? `${parentKey}.${key}` : key;
      if (!validateNestedParams(params[key], fullKey, options)) return false;
    }
  } else {
    if (params === "" || params === null || params === undefined) {
      toast.error(`${formatKey(parentKey)} cannot be empty`);
      return false;
    }
  }

  return true;
};

export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};
export const handlePhoneNumber = (dialCode, phone) => {
  if (!dialCode || !phone) return "";
  if (dialCode.startsWith("+")) {
    return `${dialCode} ${phone}`;
  } else {
    return `+${dialCode} ${phone}`;
  }
};

export const validateImageDimensions = (
  file,
  callback,
  maxWidth = 200,
  maxHeight = 200
) => {
  if (!file) {
    callback(null);
    return;
  }

  const img = new Image();
  const objectUrl = URL.createObjectURL(file);

  img.onload = () => {
    URL.revokeObjectURL(objectUrl);
    if (img.width > maxWidth || img.height > maxHeight) {
      toast.error(
        `Image dimensions should not be greater than ${maxWidth}x${maxHeight}px`
      );
      callback(null);
    } else {
      callback(file);
    }
  };

  img.onerror = () => {
    URL.revokeObjectURL(objectUrl);
    toast.error("Failed to load image");
    callback(null);
  };

  img.src = objectUrl;
};

const options = {
  onDownloadProgress: (progressEvent) => {
    const { loaded, total } = progressEvent;
  },
};

export function downloadFileFromUrl(fileUrl, filename) {
  axios
    .get(fileUrl, {
      responseType: "blob",
      ...options,
    })
    .then(function (response) {
      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: response.headers["content-type"],
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    })
    .catch((e) => {});
}

export const truncate = (text, maxLength = 50, suffix = "...") => {
  if (!text || typeof text !== "string") return text || "";
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength).trim() + suffix;
};

export const validateCommission = (value, maxValue = 100) => {
  const num = parseFloat(value);
  if (value === "" || value === null || value === undefined) {
    return true; // Allow empty values
  }
  return !isNaN(num) && num <= maxValue;
};
